import { FC, useEffect, useState } from "react";
import { ViewProps } from "../types";

export type WithURLParamsProps = {
  urlParams: string | null;
};

export const withURLParams =
  (View: FC<WithURLParamsProps>) => (props: ViewProps) => {
    const [urlParams, setUrlParams] = useState<string | null>(null);

    useEffect(() => {
      if (window?.location?.search) {
        localStorage?.setItem("urlParams", window?.location?.search);
      }
      if (localStorage?.getItem("urlParams")) {
        setUrlParams(localStorage?.getItem("urlParams"));
      } else {
        setUrlParams(
          "?utm_source=DirectLP&utm_medium=Organic&utm_campaign=DRIMO&utm_id=1"
        );
      }
    }, []);

    return <View {...props} urlParams={urlParams} />;
  };
